<template>
  <div
    :class="[
      'add-ons-list-items__lvt-wrapper',
      lvtToggler && 'add-ons-list-items__lvt-wrapper--show',
    ]"
  >
    <div
      @click="lvtToggler = !lvtToggler"
      :class="[
        'add-ons-list-items__lvt-placeholder',
        lvtToggler && 'add-ons-list-items__lvt-placeholder--show',
      ]"
    >
      <div class="add-ons-list-items__lvt-placeholder-text">Live Virtual Training</div>
      <Pill infoWhite v-if="selectedItems > 0"> {{ selectedItems }} selected </Pill>
      <ChevronDownIcon class="add-ons__chevron" />
    </div>
    <div
      v-show="lvtToggler"
      :class="[
        'add-ons-list-items__lvt-items-wrapper',
        lvtToggler && 'add-ons-list-items__lvt-items-wrapper--show',
      ]"
    >
      <div
        class="add-ons-list-items__lvt-item"
        v-for="liveVirtualTraining in lvtList"
        :key="liveVirtualTraining.merchant_id"
        @click="updateLVTsSelected(liveVirtualTraining)"
      >
        <div class="add-ons-list-items__lvt-item-starting-date">
          <div class="add-ons-list-items__lvt-item-starting-date-wrapper">
            <div class="add-ons-list-items__lvt-item-starting-date-bg">
              <div class="add-ons-list-items__lvt-item-starting-date-month">
                {{ dateParsed(liveVirtualTraining).month }}
              </div>
              <div class="add-ons-list-items__lvt-item-starting-date-day">
                {{ dateParsed(liveVirtualTraining).day }}
              </div>
            </div>
          </div>
        </div>
        <div class="add-ons-list-items__lvt-item-name">
          <div class="add-ons-list-items__lvt-item-name-text">
            {{ liveVirtualTraining.name }}
          </div>
          <div
            class="add-ons-list-items__lvt-item-included"
            v-if="
              !isAuthenticated &&
              !liveVirtualTraining.user_receives_discount &&
              liveVirtualTraining.includedFeature
            "
          >
            {{ liveVirtualTraining.includedFeature }}
          </div>
        </div>
        <div class="add-ons-list-items__lvt-item-price">
          {{ priceToShow(liveVirtualTraining) }}
        </div>
        <div class="add-ons-list-items__lvt-item-check">
          <CheckBox
            :cartTheme="true"
            :isSelected="liveVirtualTraining.addOnChecked"
            @click="updateLVTsSelected(liveVirtualTraining)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CheckBox from '@/components/shared/CheckBox.vue'
import Pill from '@/components/shared/Pill.vue'
import ChevronDownIcon from '@/assets/icons/chevron_down.svg'
import CONSTANTS from '@/constants'
import { updateCart } from '@/helpers/mixins'

const { LIVE_VIRTUAL_TRAININGS } = CONSTANTS

export default {
  name: 'AddOnsListLVTItems',
  mixins: [updateCart],
  components: {
    CheckBox,
    Pill,
    ChevronDownIcon: { ...ChevronDownIcon, name: 'ChevronDownIcon' },
  },
  data() {
    return {
      lvtList: [],
      lvtToggler: false,
      selectedItems: 0,
    }
  },
  computed: {
    ...mapState({
      liveVirtualTrainings: state => state.products.availableLiveVirtualTrainings,
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
  },
  methods: {
    updateLVTsSelected(lvt) {
      this.updateSelectedLVT(lvt, true)
      this.selectedItems = this.shoppingCart.filter(
        item =>
          Object.values(LIVE_VIRTUAL_TRAININGS).includes(item.merchant_id) &&
          item.addOn &&
          item.addOnChecked
      ).length
    },
    setLVTList() {
      let selectedItems = 0
      const lvtsIdsOnCart = this.shoppingCart.map(item => {
        if (
          Object.values(LIVE_VIRTUAL_TRAININGS).includes(item.merchant_id) &&
          item.addOn &&
          item.addOnChecked
        )
          selectedItems++
        if (Object.values(LIVE_VIRTUAL_TRAININGS).includes(item.merchant_id) && !item.addOn)
          return item.merchant_id
      })
      if (lvtsIdsOnCart.length > 0) {
        this.selectedItems = selectedItems
        this.lvtList = this.liveVirtualTrainings.filter(
          lvt => !lvtsIdsOnCart.includes(lvt.merchant_id)
        )
      } else {
        this.lvtList = this.liveVirtualTrainings
      }
    },
    dateParsed(lvt) {
      try {
        const dateParts = lvt.startDate.split(' ')
        dateParts[0] = dateParts[0].slice(0, 3)
        return {
          month: dateParts[0],
          day: dateParts[1],
        }
      } catch (error) {
        return {
          month: 'TBD',
          day: 'TBD',
        }
      }
    },
    priceToShow(lvt) {
      return lvt.user_receives_discount
        ? `$${lvt.discounted_price_cents / 100}`
        : `$${lvt.price_cents / 100}`
    },
  },
  created() {
    this.setLVTList()
  },
  watch: {
    shoppingCart: {
      immediate: true,
      handler(items) {
        this.setLVTList()
        this.$forceUpdate()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.add-ons-list-items {
  &__lvt {
    cursor: pointer;
    &-wrapper {
      height: 55px;
      background: var(--gray-3);
      border-radius: 20px;
      transition: 0.3s all ease-in-out;
      &--show {
        height: 100%;
      }
    }
    &-placeholder {
      height: 55px;
      border-radius: 20px;
      background: linear-gradient(90deg, rgba(51, 51, 51, 1) 60%);
      background-position: center right;
      background-image: var(--lvt-addons-svg-bg);
      background-repeat: no-repeat;
      display: flex;
      padding: 5px 30px;
      align-items: center;
      font-weight: 700;
      justify-content: space-between;
      gap: 10px;
      font-size: rem(16px);
      line-height: rem(23px);
      @include tablet-ipad-pro {
        font-size: rem(20px);
        line-height: rem(26px);
      }
      @include tablet {
        font-size: rem(20px);
        line-height: rem(26px);
      }
      .pill {
        white-space: nowrap;
        margin-left: auto;
      }
      &--show {
        border-radius: 20px 20px 0 0;
      }
    }
    &-items {
      display: flex;
      flex-flow: column;
      row-gap: 10px;
      &-wrapper {
        width: 100%;
        height: 0px;
        transition: 0.2s all ease-in-out;
        opacity: 0;
        padding: 20px;
        display: flex;
        flex-flow: column;
        gap: 5px;
        &--show {
          opacity: 1;
          height: 100%;
          cursor: auto;
        }
      }
    }
    &-item {
      display: grid;
      grid-template-rows: 45px auto;
      grid-template-columns: 45px auto 25px;
      grid-gap: 20px;
      @include tablet-ipad-pro {
        grid-template-columns: 43px auto 70px 25px;
        grid-template-rows: auto;
      }
      @include tablet {
        grid-template-columns: 43px auto 70px 25px;
        grid-template-rows: auto;
      }
      padding: 10px;
      border-radius: 10px;
      align-items: center;
      background: var(--glass-mid-gray);
      align-content: center;
      cursor: pointer;
      &:hover {
        background: var(--glass-extra-light);
      }
      &-check {
        display: flex;
        justify-content: center;
        .check-box {
          display: flex;
          align-items: center;
        }
      }
      &-name {
        grid-area: 2/1/3/4;
        font-weight: 500;
        font-size: rem(14px);
        line-height: rem(20px);
        @include tablet-ipad-pro {
          grid-area: auto;
        }
        @include tablet {
          grid-area: auto;
        }
      }
      &-price {
        text-align: right;
        font-size: rem(20px);
        font-weight: 700;
        line-height: rem(26px);
      }
      &-included {
        color: var(--purple-pale);
        font-size: rem(12px);
        line-height: rem(14px);
        font-weight: 400;
      }
    }
    &-item-starting-date {
      &-wrapper {
        background: var(--purple);
        background: var(--purple-gradient-four);
        border-radius: 4px;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &-bg {
        border-radius: 4px;
        background: var(--purple);
        padding: 7px 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 42px;
        height: 42px;
      }
      &-month {
        color: var(--purple-pale);
        font-size: rem(10px);
        line-height: rem(12px);
        font-weight: 400;
        text-transform: uppercase;
      }
      &-day {
        color: var(--white);
        font-size: rem(20px);
        line-height: rem(17px);
        font-weight: 700;
      }
    }
  }
}
</style>
